import formData from '../helpers/form-data';

const axios = require('axios');

// eslint-disable-next-line
const URL_PREFIX = urlPrefix;
// eslint-disable-next-line no-undef
const NEW_API_URL = apiUrl;

function requestHasFailed(resp) {
  return !Object.prototype.hasOwnProperty.call(resp, 'status') || resp.data.status !== 1;
}

function parseError(resp, errorDictionary) {
  if (requestHasFailed(resp)) {
    if (resp.data.err && typeof resp.data.err === 'object') {
      const errArr = Object.keys(resp.data.err)
        .map((errorKey) => {
          if (errorKey === 'calc' && resp.data.err[errorKey] === 'Тариф не найден') {
            return 'К сожалению, отправка по данному направлению временно приостановлена';
          }

          if (errorKey === 'receiver-office-id' && resp.data.err[errorKey] === 'Выберите отделение Boxberry') {
            return 'Произошла ошибка. Вернитесь на 2 шаг и выберите другие пункты доставки. ';
          }

          if (errorDictionary !== undefined && errorDictionary[errorKey] === '') {
            return (`${resp.data.err[errorKey]}`);
          }

          if (errorDictionary !== undefined && errorDictionary[errorKey] !== undefined) {
            return (`${errorDictionary[errorKey]}: ${resp.data.err[errorKey]}`);
          }
          return 'Произошла ошибка, попробуйте повторить позже.';
        });
      return new Error(errArr);
    }
    if (resp.data.err && resp.data.err === 'Array') {
      return new Error('Произошла ошибка. Вернитесь на 2 шаг и выберите другие пункты доставки. ');
    }
    return new Error('Произошла ошибка, попробуйте повторить позже.');
  }

  throw new Error('Unable to parse error. Response has been successfull');
}

function translateYandex(texts, sourceLanguageCode, targetLanguageCode) {
  return new Promise((resolve, reject) => {
    const url = `${NEW_API_URL}/translate/yandex`;
    const params = {
      texts: [texts],
      captcha: 'test',
    };

    if (sourceLanguageCode) {
      params.source_language_code = sourceLanguageCode;
    }
    if (targetLanguageCode) {
      params.targetLanguageCode = targetLanguageCode;
    }

    axios.post(url, params)
      .then((resp) => {
        if (!resp.data.translations || !resp.data.translations.length || !resp.data.translations[0]) {
          reject(parseError(resp));
        } else {
          resolve(resp.data.translations[0].text);
        }
      });
  });
}

function exportAttachmentsAdd(attachment) {
  return new Promise((resolve, reject) => {
    const url = `${NEW_API_URL}/export/attachments/add`;
    const params = {
      attachment,
    };

    axios({
      method: 'post',
      url,
      data: formData(params),
    }).then((resp) => {
      if (!resp.data || !resp.data.linkCompressImage) {
        reject(parseError(resp));
      } else {
        resolve(resp.data.linkCompressImage);
      }
    })
      .catch((error) => {
        console.error(error);
      });
  });
}

function exportCost(price, numericCode) {
  return new Promise((resolve, reject) => {
    const url = `${NEW_API_URL}/cbr/export/cost`;
    const params = {
      price,
      numeric_code: numericCode,
    };

    axios({
      method: 'post',
      url,
      data: formData(params),
    }).then((resp) => {
      if (!resp.data || !resp.data.total) {
        reject(parseError(resp));
      } else {
        resolve(resp.data.total);
      }
    });
  });
}


export {
  translateYandex,
  exportAttachmentsAdd,
  exportCost,
};
